// extracted by mini-css-extract-plugin
export default {"ns_section":"NSSection_ns_section__A1Bz6"};